import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ObjectDataDto } from "../../models/generic/search-config.dto";

@Injectable({
    providedIn: 'root'
})
export class SendInfoComponentService {

  obj: ObjectDataDto = {
    isExecuted: true,
    value: undefined
  }
  private sendListSearch$ = new BehaviorSubject<ObjectDataDto>(this.obj);
  private sendObject$ = new BehaviorSubject<ObjectDataDto>(this.obj);
  private clickButtonSearch$ = new BehaviorSubject<ObjectDataDto>(this.obj);
  private clickButtonDelete$ = new BehaviorSubject<ObjectDataDto>(this.obj);
  private clickButtonClear$ = new BehaviorSubject<ObjectDataDto>(this.obj);

  searchAction = this.clickButtonSearch$.asObservable();
  cleanFormAction = this.clickButtonClear$.asObservable();
  deleteAction = this.clickButtonDelete$.asObservable();
  sendListAction = this.sendListSearch$.asObservable();
  sendObjectAction = this.sendObject$.asObservable();

  objPat: ObjectDataDto = {
    isExecuted: false,
    value: undefined
  }
  patientInfo$ = new BehaviorSubject<ObjectDataDto>(this.objPat);
  patientData = this.patientInfo$.asObservable();

  constructor() { }

  onClickSearch(objFind: any, key: string){
    this.clickButtonSearch$.value.isExecuted = true;
    this.clickButtonSearch$.next(this.getObject(objFind, key, true));
  }
  onPausedSearchAction(paused: boolean){
    this.clickButtonSearch$.value.isExecuted = paused;
  }

  onClickCleanForm(key: string){
    this.clickButtonClear$.value.isExecuted = true;
    this.clickButtonClear$.next(this.getObject(true, key, true));
  }
  onPausedCleanAction(paused: boolean){
    this.clickButtonClear$.value.isExecuted = paused;
  }

  onClickDelete(objDel: any, key: string){
    this.clickButtonDelete$.value.isExecuted = true;
    this.clickButtonDelete$.next(this.getObject(objDel, key, true));
  }
  onPausedDeleteAction(paused: boolean){
    this.clickButtonDelete$.value.isExecuted = paused;
  }

  sendListToSearch(list: any, key:string){
    this.sendListSearch$.next(this.getObject(list, key, true, true));
  }

  sendObject(obj: any, key:string){
    this.sendObject$.next(this.getObject(obj, key, true));
  }

  private getObject(value: any, key: string, executed: boolean, isMap?: boolean){
    let obj: ObjectDataDto = {
      isExecuted: executed,
      value: value,
      key: key
    }
    if (isMap) {
      obj.listMap = value;
      obj.value = {};
    }
    return obj;
  }
}